import React from 'react';
import { detectMobile } from '../../../utils/UiHelper';
import {
    SkeletonContainer,
    SkeletonLine,
    SkeletonButton,
    RowSkeletonCard,
    RowSkeletonLeft,
    RowSkeletonRight,
    RowSkeletonList,
} from '../styled';
import { SkeletonAnimation } from '../skeletonAnimation';

const ViewEventListSkeleton = ({ keyword, rowCount = 6, margin = '0' }) => {
    const isMobile = detectMobile();
    const buttonCount = isMobile ? 3 : 5;

    const renderSkeletonCard = () =>
        Array.from({ length: rowCount }, (_, index) => (
            <RowSkeletonCard key={`${keyword}_${index}`}>
                <RowSkeletonLeft>
                    {isMobile && (
                        <SkeletonLine
                            width={'36px'}
                            height={'20px'}
                            margin={'0 0 11px'}
                            radius={'4px'}
                        />
                    )}
                    <SkeletonLine
                        width={isMobile ? '84px' : '127px'}
                        height={isMobile ? '12px' : '10px'}
                        margin={isMobile ? '0 0 4px' : '0 0 8px'}
                        radius={isMobile ? '17px' : '15px'}
                    />
                    <SkeletonLine
                        width={isMobile ? '112px' : '75px'}
                        height={isMobile ? '12px' : '10px'}
                        margin={'0'}
                        radius={isMobile ? '17px' : '15px'}
                    />
                </RowSkeletonLeft>
                <RowSkeletonRight>
                    {Array.from({ length: buttonCount }, (_, btnIndex) => (
                        <SkeletonButton
                            key={`${keyword}_btn_${btnIndex}`}
                            width={isMobile ? '59px' : '130px'}
                            height={'42px'}
                            margin={
                                btnIndex === 2 || btnIndex === 4
                                    ? '0 4px 0 0'
                                    : '0'
                            }
                        />
                    ))}
                    {!isMobile && (
                        <SkeletonButton
                            key={`${keyword}_btn_last`}
                            width={'40px'}
                            height={'40px'}
                            margin={'0'}
                            shrink={'0'}
                        />
                    )}
                </RowSkeletonRight>
            </RowSkeletonCard>
        ));

    return (
        <SkeletonContainer padding={'0'} isMobile={isMobile} margin={margin}>
            <SkeletonLine
                height={'40px'}
                margin={'0 0 22px'}
                radius={'4px 4px 0px 0px'}
            />
            <RowSkeletonList>{renderSkeletonCard()}</RowSkeletonList>
            <SkeletonAnimation />
        </SkeletonContainer>
    );
};

export default ViewEventListSkeleton;
